module.exports = __webpack_public_path__ + "static/media/treedamage.7bda0344.jpg";